import DebitCardInformation from './DebitCardInformation';

export default DebitCardInformation;
